// Utility function for Base64URL encoding
export function base64urlEncode(str) {

       // Encode the string to Base64
       const base64 = btoa(unescape(encodeURIComponent(str)));
       // Replace characters and remove padding
       return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

  };
  export function base64urlDecode(base64url) {
       // Replace characters and add padding
       const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
       const padding = '='.repeat((4 - base64.length % 4) % 4);
       const base64WithPadding = base64 + padding;
       // Decode Base64 to a string
       return decodeURIComponent(escape(atob(base64WithPadding)));
  };